import { A, useNavigate } from "@solidjs/router";
import { For, Show } from "solid-js";
import {
  EVAL_BATCH_STATUS_COPY,
  EVAL_BATCH_STATUS_TONE,
} from "../../enums/evals";
import { relativeAge } from "../../ui/format";
import { EvalBatchLaunchForm } from "./EvalBatchLaunchForm";
import {
  createEvalBatches,
  createEvalSuites,
  invalidateEvalBatches,
} from "./evalQueries";

/** One suite: what has been run over it, and the way to run another. */
export function EvalSuiteDetail(props: { suiteId: string }) {
  const navigate = useNavigate();
  const suites = createEvalSuites();
  const batches = createEvalBatches(() => props.suiteId);
  const suite = () =>
    suites.data?.find((candidate) => candidate.suiteId === props.suiteId);

  const onLaunched = async (batchId: string) => {
    await invalidateEvalBatches(props.suiteId);
    navigate(`/evals/batches/${batchId}`);
  };

  return (
    <main class="landing">
      <div class="landing-bar">
        <A href="/evals" class="landing-brand">
          ← Evals
        </A>
        <span class="landing-tag">Suite</span>
      </div>
      <div class="landing-main">
        <div class="landing-head-row">
          <div>
            <h1 class="landing-h1">{suite()?.name ?? "Suite"}</h1>
            <p class="landing-sub pg-lede">
              <Show when={suite()}>
                {(current) => <>{current().websiteCount} pages under test</>}
              </Show>
            </p>
          </div>
        </div>

        <EvalBatchLaunchForm
          suiteId={props.suiteId}
          onLaunched={(batchId) => void onLaunched(batchId)}
        />

        <section class="panel">
          <div class="panel-head">
            <span class="panel-title">Batches</span>
          </div>
          <Show
            when={batches.data}
            fallback={<div class="loading">Loading batches…</div>}
          >
            {(data) => (
              <Show
                when={data().length > 0}
                fallback={
                  <div class="empty">
                    <div class="empty-title">No batches yet</div>
                    <div class="empty-hint">
                      Launch one above to compare two configurations.
                    </div>
                  </div>
                }
              >
                <table class="tbl tbl-link">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Variant A</th>
                      <th>Variant B</th>
                      <th>Started</th>
                      <th>Finished</th>
                    </tr>
                  </thead>
                  <tbody>
                    <For each={data()}>
                      {(batch) => (
                        <tr
                          class="tbl-row"
                          onClick={() =>
                            navigate(`/evals/batches/${batch.batchId}`)
                          }
                        >
                          <td>
                            <span
                              class={`badge badge-status ${EVAL_BATCH_STATUS_TONE[batch.status]}`}
                            >
                              {EVAL_BATCH_STATUS_COPY[batch.status]}
                            </span>
                          </td>
                          <td class="mono">
                            {batch.variantA.label}
                            <div class="landing-sub">
                              {batch.variantA.agentModel}
                            </div>
                          </td>
                          <td class="mono">
                            {batch.variantB.label}
                            <div class="landing-sub">
                              {batch.variantB.agentModel}
                            </div>
                          </td>
                          <td>{relativeAge(batch.createdAt)}</td>
                          <td>{relativeAge(batch.finishedAt)}</td>
                        </tr>
                      )}
                    </For>
                  </tbody>
                </table>
              </Show>
            )}
          </Show>
        </section>
      </div>
    </main>
  );
}
